export enum ApplicationMenuState {
    MAIN,
    GAME,
}